<template>
  <div
    class="h-full min-h-screen md:min-h-0 flex flex-col breaker"
    v-if="dataObj"
  >
    <NavMenu class="z-20" />
    <div
      :class="themeIsDark ? 'bg-black text-white' : 'bg-white text-black'"
      class="flex-1 md:overflow-y-scroll relative md:pb-64 px-10 pt-10"
    >
      <div class="relative z-10 mb-12">
        <p
          class="text-xl font-bold text-center mb-6 md:mx-20"
          :style="$themeStyle"
        >
          {{ dataObj.title }}
        </p>
        <p class="text-sm text-center md:mx-20" :style="$themeStyle">
          {{ dataObj.text }}
        </p>
      </div>
      <AnimationCard :id="dataObj.animation" />
    </div>
    <div>
      <div
        :class="themeIsDark ? ' text-white' : ' text-black'"
        class="p-10 fixed left-0 md:absolute bottom-0 w-full"
      >
        <router-link class="mb-8" :to="dataObj.linkUrl">
          <Button :title="dataObj.button" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { TranslationHandler } from '../../mixins/translation-handler'
import { Component, Mixins } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { ThemeHandler } from '../../mixins/theme-handler'

enum BreakerId {
  SEARCH = 'search',
  SORT = 'sort',
  OPENING = 'opening',
  CLOSING = 'closing',
  ENCORE = 'encore',
}

@Component({
  components: {
  }
})
export default class Breaker extends Mixins(TranslationHandler, ThemeHandler) {
  @Getter themeIsDark!: boolean
  @Getter themePrimaryColor!: string
  @Getter themeLogoImageUrl!: string
  @Action('ENSURE_STEP_NAME') ensureStepName!: (stepName: string) => void

  breakerId: BreakerId | null = null

  mounted () {
    this.ensureStepName('Playlist')
    const id = this.$route.params.id

    if (id) {
      this.breakerId = (id as BreakerId)
    }
  }

  get dataObj (): { text: string, title: string, button: string, animation: string, linkUrl: string } | null {
    switch (this.breakerId) {
      case BreakerId.SEARCH: {
        return {
          title: this.$t('breakerSearchTitle'),
          text: this.$t('breakerSearchText'),
          button: this.$t('breakerSearchButton'),
          animation: 'playlist',
          linkUrl: '/search-tracks',
        }
      }
      case BreakerId.SORT: {
        return {
          title: this.$t('breakerSortTitle'),
          text: this.$t('breakerSortText'),
          button: this.$t('breakerSortButton'),
          animation: 'playlistWithNoteMoving',
          linkUrl: '/playlist-sort',
        }
      }
      case BreakerId.OPENING: {
        return {
          title: this.$t('breakerOpeningTitle'),
          text: this.$t('breakerOpeningText'),
          button: this.$t('breakerOpeningButton'),
          animation: 'playlist',
          linkUrl: '/playlist-favorite/opening',
        }
      }
      case BreakerId.CLOSING: {
        return {
          title: this.$t('breakerClosingTitle'),
          text: this.$t('breakerClosingText'),
          button: this.$t('breakerClosingButton'),
          animation: 'playlist',
          linkUrl: '/playlist-favorite/closing',
        }
      }
      case BreakerId.ENCORE: {
        return {
          title: this.$t('breakerEncoreTitle'),
          text: this.$t('breakerEncoreText'),
          button: this.$t('breakerEncoreButton'),
          animation: 'playlist',
          linkUrl: '/playlist-favorite/encore',
        }
      }
      default: {
        return null
      }
    }
  }
}
</script>
